import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { IconInformation, Typography } from '@klarna/bubble-ui';
import { Alert, FlowContext } from 'moet-core';
import { isRunningContextCypress } from 'moet-test-utils/cypress/utils';
import { GridContainer, Row, Column, withResponsive, VerticalRhythm } from 'mage-components';
import { ErrorAlert } from './ErrorAlert';
import { RouteTransitionWrapper } from './RouteTransitionWrapper';

/* eslint-disable no-restricted-imports */
// @ts-expect-error: FIXME
import step1 from '../../static/BrandAssetLibrary_2024_ConsumerBenefit_Slide_4x5.jpg';
/* eslint-disable no-restricted-imports */

const SplitImage = styled.div`
  background: ${`url(${step1}) center no-repeat`};
  background-color: #eb6f93;
  background-size: cover;
  height: 100vh;
  width: 50vw;
  z-index: 1;
  position: fixed;
`;

const ContentBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 100%;
  margin: 0 auto;
  max-width: unset;
`;

export type PspContainerProps = {
  isMobile: boolean;
  subtitle: string;
  title: string;
  children?: React.ReactNode;
  contentWidth?: number;
  info?: string;
  error?: any;
};

export const PspContainerComponent = ({
  isMobile,
  subtitle,
  title,
  children = null,
  contentWidth = 6,
  info,
  error = undefined,
}: PspContainerProps): React.JSX.Element => {
  // @ts-expect-error: FIXME
  const { navigation = {} } = useContext<FlowContext>(FlowContext);

  return (
    <RouteTransitionWrapper
      name={navigation.key}
      direction={navigation.direction}
      disabled={isRunningContextCypress(window)}
    >
      <GridContainer
        extraStyles={{
          overflow: 'unset',
          maxWidth: 'unset',
          display: 'flex',
          minHeight: '100vh',
          flexDirection: 'column',
        }}
      >
        <Row spacing={{ mobile: 0 }} extraStyles={{ flex: 1 }}>
          <Column
            columns={{ mobile: 12, desktop: contentWidth > 6 ? 12 : 6 }}
            justify={{ mobile: 'space-between' }}
          >
            <Row justify="center" spacing={{ mobile: 0 }}>
              <Column columns={{ mobile: 10, tablet: 9 }}>
                <RouteTransitionWrapper
                  name={navigation.key}
                  direction={navigation.direction}
                  disabled={isRunningContextCypress(window)}
                >
                  <ContentBlock>
                    <VerticalRhythm spacing={{ mobile: 5, tablet: 9 }} />
                    <VerticalRhythm spacing={{ mobile: 5, tablet: 9 }} />
                    {isMobile ? (
                      <Typography
                        textToken="text-style/headings/titles/bold/primary"
                        accessibilityPreset="heading 1"
                      >
                        {title}
                      </Typography>
                    ) : (
                      <Typography
                        textToken="text-style/headings/titles/bold/huge"
                        accessibilityPreset="heading 1"
                      >
                        {title}
                      </Typography>
                    )}
                    {subtitle && (
                      <>
                        <VerticalRhythm spacing={{ mobile: 6 }} />
                        {isMobile ? (
                          <Typography textToken="text-style/text/super-paragraphs/body/regular">
                            {subtitle}
                          </Typography>
                        ) : (
                          <Typography textToken="text-style/text/super-paragraphs/tall/regular">
                            {subtitle}
                          </Typography>
                        )}
                      </>
                    )}
                    {error && (
                      <>
                        <VerticalRhythm spacing={{ mobile: 6 }} />
                        <ErrorAlert error={error} />
                      </>
                    )}
                    {info && (
                      <>
                        <VerticalRhythm spacing={{ mobile: 6 }} />
                        {/* @ts-expect-error: FIXME */}
                        <Alert content={info} icon={IconInformation} />
                      </>
                    )}
                    <VerticalRhythm spacing={{ mobile: 6, tablet: 10 }} />
                    {children}
                    <VerticalRhythm spacing={{ mobile: 10, tablet: 12 }} />
                  </ContentBlock>
                </RouteTransitionWrapper>
              </Column>
            </Row>
          </Column>

          <Column
            columns={{ desktop: 6 }}
            display={{
              mobile: 'none',
              tablet: 'none',
              ...(contentWidth > 6 ? { desktop: 'none' } : {}),
            }}
          >
            <SplitImage />
          </Column>
        </Row>
      </GridContainer>
    </RouteTransitionWrapper>
  );
};

PspContainerComponent.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  subtitle: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  contentWidth: PropTypes.number,
  error: PropTypes.object,
  info: PropTypes.string,
};

export const PspContainer = withResponsive(PspContainerComponent);
